module.exports = __webpack_public_path__ + "media/images/haircut/cover-desktop@3x-212aeadab1fb1e60c6fa3a0003508300.jpg";